import { sensorConstants } from "../_constants";

export function sensor(state = {}, action) {
  switch (action.type) {
  case sensorConstants.SENSOR_ON:
    return {
      ...state,
      isSensorOn: true,
      isSensorOnValue: "visible"
    };
  case sensorConstants.SENSOR_OFF:
    return {
      ...state,
      isSensorOn: false,
      isSensorOnValue: "none"
    };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/sensor.reducer.js